//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { theme } from '~/tailwind.config.js'

gsap.registerPlugin(ScrollTrigger)

export default {
  props: {
    rows: {
      type: Array,
      required: true
    },
    activeVariantSku: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      componentKey: 0,
      mdBreakpoint: theme.extend.screens.md,
      isMdBreakpointOrAbove: false
    }
  },

  computed: {
    filteredRows () {
      return this.rows.filter(this.testSkuPattern)
    },

    mediaQueryList () {
      return window.matchMedia(`(min-width: ${this.mdBreakpoint})`)
    }
  },

  watch: {
    isMdBreakpointOrAbove () {
      this.componentKey++
    }
  },

  mounted () {
    this.mediaQueryListMatches()
    this.mediaQueryList.addListener(this.mediaQueryListMatches)

    // const rows = document.querySelectorAll('.ContentLoop__row')
    const imageStacks = document.querySelectorAll('.js-content-multi_column')

    this.timeout = setTimeout(() => {
      if (this.$refs.item) this.initRowAnimation()
      if (imageStacks) this.initImageStackAnimation()
    }, 200)
  },

  destroyed () {
    this.mediaQueryList.removeListener(this.mediaQueryListMatches)

    if (this.stackTl) {
      Object.keys(this.stackTl).forEach((item, index) => {
        this.stackTl[index].kill()
      })
    }

    if (this.rowTl) {
      Object.keys(this.rowTl).forEach((item, index) => {
        this.rowTl[index].kill()
      })
    }

    if (this.timeout) clearTimeout(this.timeout)
  },

  methods: {
    initImageStackAnimation () {
      // Get all image stacks in columns
      const imageStacks = document.querySelectorAll('.js-content-multi_column')

      this.stackTl = {}

      // Loop through all of them
      imageStacks.forEach((item) => {
        const image = item.querySelectorAll('.BaseStack__media')

        image.forEach((imageItem, index) => {
          const imageCanvas = imageItem.querySelectorAll('.BaseStack__media-container')
          // If more or equal to 3 images, execute.
          if (image.length >= 3) {
            this.stackTl[index] = gsap.timeline({
              defaults: {
                duration: 1,
                ease: 'none'
              },
              scrollTrigger: {
                trigger: imageItem,
                start: 'top bottom',
                end: 'center center',
                scrub: 0.25,
                id: 'stackTl'
                // markers: true
              }
            })
            this.stackTl[index]
              .fromTo(imageCanvas, {
                scale: 1.15,
                z: 0
              },
              {
                scale: 1,
                z: 0
              })
          }
        })
      })
    },

    initRowAnimation () {
      this.rowTl = {}

      this.$refs.item.forEach((item, index) => {
        this.rowTl[index] = gsap.timeline({
          defaults: {
            duration: 1.5,
            ease: 'power3.out'
          },
          scrollTrigger: {
            trigger: item.$el,
            start: 'top 90%',
            end: 'bottom 75%',
            id: 'rowTl'
            // markers: true
          }
        })

        this.rowTl[index]
          .fromTo(item.$el, {
            opacity: 0.5
          },
          {
            opacity: 1
          })
      })
    },

    mediaQueryListMatches () {
      this.isMdBreakpointOrAbove = this.mediaQueryList.matches
    },

    filterBlankColumns (columns) {
      return this.isMdBreakpointOrAbove ? columns : columns.filter(column => column.type !== 'blank')
    },

    rowComponent (row) {
      return row.type === 'multi_column' && row.carouselOnMobile ? 'slider-row' : 'base-row'
    },

    rowHasProductCards (row) {
      return this.getCurrentRowType(row) === 'multi_column' && row.columns.filter(column => column.type === 'product_card').length > 0
    },

    rowHasMedia (row) {
      return row.columns.filter(column => !!column.image && !!column.image.src).length > 0
    },

    getCurrentRowType (row) {
      return row.type
    },

    getNextVisibleRow (index) {
      // If this row is only visible on desktop then return the next where visibility is 'desktop' or 'everywhere'
      // If this row is only visible on mobile then return the next where visibility is 'mobile' or 'everywhere'
      // If this row is visible everywhere then return the next row

      if (this.isLastRow(index)) return false

      const isVisibleEverywhere = row => row.visibility === 'everywhere'
      const visibilityMatches = nextRow => isVisibleEverywhere(this.filteredRows[index]) ||
        isVisibleEverywhere(nextRow) ||
        this.filteredRows[index].visibility === nextRow.visibility

      return this.filteredRows.slice(index + 1).find(visibilityMatches) || false
    },

    isLastRow (index) {
      return index + 1 === this.filteredRows.length
    },

    isFullWidthRow (row) {
      const rowType = this.getCurrentRowType(row)
      return (rowType === 'banner' && row.fullWidth) || (rowType === 'video' && row.fullWidth)
    },

    verticalSpacingClasses (row, index) {
      const rowType = this.getCurrentRowType(row)
      const nextRow = this.getNextVisibleRow(index)
      return [
        {
          'ContentLoop__row--margin-none':
            (this.isFullWidthRow(row) && (this.isFullWidthRow(nextRow) || this.isLastRow(index))) || row.disableBottomMargin
        },
        {
          'ContentLoop__row--margin-top-regular': index === 0 && (rowType !== 'banner' && rowType !== 'video')
        },
        {
          'ContentLoop__row--margin-bottom-small': (rowType === 'heading' || rowType === 'standfirst' || rowType === 'divider') && !row.disableBottomMargin
        },
        {
          'ContentLoop__row--margin-bottom-tiny': (this.rowHasProductCards(row) && this.rowHasProductCards(nextRow)) || row.disableBottomMargin
        }
      ]
    },

    testSkuPattern (row) {
      if (!this.activeVariantSku) return true // If no active SKU is set then default to showing the block
      if (!row.skuPattern) return true // If no SKU pattern is set then show the block
      return !!this.activeVariantSku.match(row.skuPattern)
    }
  }
}
